"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useMeasure3 = _interopRequireDefault(require("react-use/lib/useMeasure"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./vertical-products-wrapper.less");

var styles = {
  "wrapper": "meepshop-meep-ui__submenu-largeMenuWithProducts-vertical-products-wrapper__wrapper",
  "arrow": "meepshop-meep-ui__submenu-largeMenuWithProducts-vertical-products-wrapper__arrow",
  "prev": "meepshop-meep-ui__submenu-largeMenuWithProducts-vertical-products-wrapper__prev",
  "next": "meepshop-meep-ui__submenu-largeMenuWithProducts-vertical-products-wrapper__next",
  "arrowButton": "meepshop-meep-ui__submenu-largeMenuWithProducts-vertical-products-wrapper__arrowButton"
};

var PrevIcon = function PrevIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "36",
    height: "36",
    rx: "18",
    fill: "currentColor",
    fillOpacity: "0.06"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.7852 12.754V11.3736C21.7852 11.254 21.6477 11.1879 21.5548 11.2611L13.5048 17.5486C13.4364 17.6018 13.3811 17.6699 13.343 17.7477C13.3049 17.8256 13.2852 17.9111 13.2852 17.9977C13.2852 18.0844 13.3049 18.1699 13.343 18.2477C13.3811 18.3255 13.4364 18.3936 13.5048 18.4468L21.5548 24.7343C21.6495 24.8075 21.7852 24.7415 21.7852 24.6218V23.2415C21.7852 23.154 21.7441 23.07 21.6763 23.0165L15.2477 17.9986L21.6763 12.979C21.7441 12.9254 21.7852 12.8415 21.7852 12.754Z",
    fill: "currentColor"
  }));
};

var NextIcon = function NextIcon() {
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "36",
    height: "36",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "36",
    height: "36",
    rx: "18",
    fill: "currentColor",
    fillOpacity: "0.06"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.5304 17.5524L14.4804 11.2649C14.4593 11.2483 14.434 11.238 14.4074 11.2352C14.3808 11.2323 14.3539 11.2371 14.3299 11.2488C14.3058 11.2606 14.2856 11.2789 14.2714 11.3016C14.2573 11.3243 14.2499 11.3506 14.25 11.3774V12.7577C14.25 12.8452 14.2911 12.9292 14.3589 12.9827L20.7875 18.0024L14.3589 23.022C14.2893 23.0756 14.25 23.1595 14.25 23.247V24.6274C14.25 24.747 14.3875 24.8131 14.4804 24.7399L22.5304 18.4524C22.5988 18.399 22.6541 18.3307 22.6922 18.2528C22.7303 18.1748 22.7501 18.0891 22.7501 18.0024C22.7501 17.9156 22.7303 17.83 22.6922 17.752C22.6541 17.674 22.5988 17.6057 22.5304 17.5524Z",
    fill: "currentColor"
  }));
};

function VerticalProductsWrapper(_ref) {
  var children = _ref.children,
      itemWidth = _ref.itemWidth,
      imageRatio = _ref.imageRatio,
      count = _ref.count;
  var contentWidth = itemWidth * count + 16 * (count - 1);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      index = _useState2[0],
      setIndex = _useState2[1];

  var _useMeasure = (0, _useMeasure3["default"])(),
      _useMeasure2 = (0, _slicedToArray2["default"])(_useMeasure, 2),
      ref = _useMeasure2[0],
      width = _useMeasure2[1].width;

  var animatedRef = (0, _react.useRef)(null);
  var shouldScrollable = contentWidth > width;
  var itemHeight = (0, _react.useMemo)(function () {
    var ratio = imageRatio.split('/');

    if (ratio.length === 2) {
      return itemWidth / ratio[0] * ratio[1];
    }

    return itemWidth;
  }, [itemWidth, imageRatio]);
  (0, _react.useEffect)(function () {
    if (animatedRef.current) {
      var translateX = index * itemWidth + 16 * index;
      animatedRef.current.style.transform = "translateX(-".concat(translateX, "px)");
    }
  }, [index, itemWidth]);
  var isNextDisabled = (0, _react.useMemo)(function () {
    if (animatedRef.current) {
      var translateX = index * itemWidth + 16 * index;
      return contentWidth - translateX <= width;
    }

    return false;
  }, [contentWidth, index, itemWidth, width]);
  (0, _react.useEffect)(function () {
    // 當 screen resize 時，要重新計算 index
    setIndex(0);
  }, [width]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: styles.wrapper,
    style: {
      padding: shouldScrollable ? '0 44px' : 0
    }
  }, shouldScrollable && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.arrow, " ").concat(styles.prev)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: styles.arrowButton,
    style: {
      height: itemHeight
    },
    type: "button",
    disabled: index === 0,
    onClick: function onClick() {
      return setIndex(index - 1);
    }
  }, /*#__PURE__*/_react["default"].createElement(PrevIcon, null))), /*#__PURE__*/_react["default"].createElement("div", {
    ref: animatedRef,
    style: {
      width: contentWidth,
      transition: 'transform 0.3s ease-in-out',
      marginLeft: 'auto'
    }
  }, children), shouldScrollable && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.arrow, " ").concat(styles.next)
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: styles.arrowButton,
    style: {
      height: itemHeight
    },
    type: "button",
    disabled: index === count - 1 || isNextDisabled,
    onClick: function onClick() {
      return setIndex(index + 1);
    }
  }, /*#__PURE__*/_react["default"].createElement(NextIcon, null))));
}

var _default = VerticalProductsWrapper;
exports["default"] = _default;